/** @format */

import { TRoom } from '@/@ducks/room/declarations';
import { TLocale } from '@/utils/gatsby/types';

export const findLocalizedData = (
  locale: TLocale,
  localizedData?: TRoom['localizedData'],
): TRoom['localizedData'][0] | undefined => {
  if (!localizedData || localizedData.length === 0) {
    console.warn('[LocalizedData] missing localized data!');
    return undefined;
  }
  if (localizedData.some(el => !('language' in el)))
    throw new Error(`[LocalizedData] No language for element ${JSON.stringify(localizedData, null, 2)}`);

  return localizedData.find(el => el.language.includes(locale));
};
